<woa-modal-page-layout [title]="'woa.heading.order.notes'">
    <woa-text-area-field [(ngModel)]="notes" name="message"></woa-text-area-field>
    <woa-button woa-page-footer-control [label]="'woa.button.common.continue'" (onActivate)="confirmNotes()"></woa-button>
</woa-modal-page-layout>
